import { ActionDataTransformation } from './AnalyticsManager.types'

export const actionDataTransformations = {
	[ActionDataTransformation.REGEX](value: string, regex: string, global = true): string {
		try {
			const reg = new RegExp(regex, global ? 'g' : '')
			return value.replace(reg, '')
		} catch (error) {
			console.error('Invalid regex:', regex, error)
			return value
		}
	},
	[ActionDataTransformation.JSON_STRINGIFY](value: string): string {
		try {
			return JSON.stringify(value)
		} catch (error) {
			console.error('Invalid JSON:', value, error)
			return value
		}
	},
}

export const applyTransformations = (
	transformations: { name: ActionDataTransformation; arguments: (number | string)[] }[] | undefined,
	initialValue: number | string
) => {
	let transformedValue = initialValue
	if (!transformations || !Array.isArray(transformations)) {
		return transformedValue
	}

	for (const transformation of transformations) {
		const transformationName = transformation.name as ActionDataTransformation
		const transformerArguments = transformation.arguments

		if (!actionDataTransformations[transformationName] || typeof actionDataTransformations[transformationName] !== 'function') {
			continue
		}

		transformedValue = (actionDataTransformations[transformationName] as unknown as (...args: (string | number)[]) => string)(
			transformedValue as string,
			...transformerArguments
		)
	}

	return transformedValue
}
